import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress, Container, Paper, Typography } from "@mui/material";
import { onlineStatus } from "../api/online";
import { bookingResultFromStatus } from "../services/mobileCheckout";
import { setBookingResult } from "../redux/slices/bookingSlice";
import PaymentPage from "./PaymentPage";

// Ulazna tačka mobilne aplikacije (WebView): /placanje/m/{merchantPaymentId}.
// Stanje se rekonstruiše iz suženog /status DTO-a pa se renderuje POSTOJEĆI
// PaymentPage — web tok kroz redux ostaje netaknut (aditivna ruta).
export default function MobileCheckoutPage() {
    const { merchantPaymentId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [state, setState] = useState("loading"); // loading | ready | gone | error

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await onlineStatus(merchantPaymentId);
                if (cancelled) return;
                const dto = response?.data || response;
                if (dto?.status === "COMPLETED") {
                    navigate("/potvrda", { replace: true });
                    return;
                }
                const bookingResult = bookingResultFromStatus(dto);
                if (!bookingResult) {
                    setState("gone");
                    return;
                }
                dispatch(setBookingResult(bookingResult));
                setState("ready");
            } catch (error) {
                console.error("Greška pri učitavanju rezervacije:", error);
                if (!cancelled) setState("error");
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [merchantPaymentId, dispatch, navigate]);

    if (state === "ready") return <PaymentPage embedded />;

    return (
        <Container maxWidth="sm" sx={{ py: 10 }}>
            <Paper sx={{ p: 4, borderRadius: 3, textAlign: "center" }}>
                {state === "loading" ? (
                    <>
                        <CircularProgress sx={{ mb: 2 }} />
                        <Typography>{t("mobileCheckout.loading")}</Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                            {t(state === "gone" ? "mobileCheckout.gone" : "mobileCheckout.error")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {t("mobileCheckout.backHint")}
                        </Typography>
                        <Box>
                            <Button variant="contained" onClick={() => navigate("/")}>
                                {t("mobileCheckout.home")}
                            </Button>
                        </Box>
                    </>
                )}
            </Paper>
        </Container>
    );
}
